import UseAxios from '../../../Api/http/http';
import { getAwardDetails } from '../../../Api/request/achievements';
import { certificationMapList } from '../../../Api/request/certificationmap';
import { getDriDetails } from '../../../Api/request/performance';
import { getMappedSkills } from '../../../Api/request/skillMap';

export const fetchMappedSkills = async (userId) => {
  try {
    const response = await UseAxios(getMappedSkills(userId));
    return response.data;
  } catch (error) {
    console.error('Error fetching users mapped skills:', error);
    throw error;
  }
};

export const fetchMapCertifications = async (userId) => {
  try {
    const response = await UseAxios(
      certificationMapList(null, null, null, null, userId),
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching users mapped certifications:', error);
    throw error;
  }
};

export const fetchAwards = async (userId) => {
  try {
    const response = await UseAxios(getAwardDetails(userId));
    return response.data;
  } catch (error) {
    console.error('Error fetching users award details:', error);
    throw error;
  }
};

export const fetchDri = async (emailId) => {
  try {
    const response = await UseAxios(getDriDetails(emailId));
    return response.data;
  } catch (error) {
    console.error('Error fetching users DRI details:', error);
    throw error;
  }
};

export const getColorForDRIScore = (score) => {
  if (score <= 15) return 'red';
  if (score <= 50) return 'orange';
  if (score <= 75) return 'blue';
  return 'green';
};

export const formatDate = (dateString) => {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};
